<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative;display:flex;justify-content: space-between;height: 28px;line-height: 28px;">
        <Breadcrumb>
          <BreadcrumbItem to="/home">
            <Icon type="icon iconfont icon-xitong" /> 系统首页
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Icon type="icon iconfont icon-xitonghoutai" /> 系统管理
          </BreadcrumbItem>
          <BreadcrumbItem to="/system/adminlist">
            <Icon type="icon iconfont icon-message1" /> 企业管理
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Icon type="icon iconfont icon-message" /> 管理
          </BreadcrumbItem>
        </Breadcrumb>
        <i-button class="refresh" size="small" type="success">
          <Icon title="刷新" class="icon" type="ios-refresh" @click="reload" />
        </i-button>
      </div>
      <!-- 位置条 -->
      <Card style="margin-top: 12px;">
        <Tabs>

          <TabPane v-if="yytypes == 0" :label="'工况/'+comName" icon="icon iconfont icon-gongkuangtu">
            <div class="MenuItem-box">
              <mystie v-if="show" :datalist="gkList" />
            </div>
          </TabPane>
          <TabPane v-else-if="yytypes == 1" :label="'油烟/'+comName" icon="icon iconfont icon-youyanji">
            <div class="MenuItem-box">
              <mystie v-if="show" :datalist="gkList" />
            </div>
          </TabPane>
          <TabPane v-else-if="yytypes == 2" :label="'在线/'+comName" icon="icon iconfont icon-yangan">
            <div class="MenuItem-box">
              <mystie v-if="show" :datalist="gkList" />
            </div>
          </TabPane>
		  <TabPane v-else-if="yytypes == 3" :label="'扬尘/'+comName" icon="icon iconfont icon-yangchen1">
		    <div class="MenuItem-box">
		      <mystie v-if="show" :datalist="gkList" />
		    </div>
		  </TabPane>

        </Tabs>
      </Card>
    </X-Layout>

  </div>
</template>

<script>
import mystie from '../../../components/mystie.vue';
export default {
    components: {
        mystie
    },
    data() {
        return {
            theme1: 'light',
            gkList: [], // 内容
            show: false,
            yytypes: '',
            comName: ''
        };
    },

    created() {
        const id = this.$route.query.comid;
		
        this.yytypes = sessionStorage.getItem('yytype');
        
        sessionStorage.setItem('comid', id);
        const that = this;
        const api = this.ApiUrl + 'gkSensor/findByCompanySensor';
        const data = {
            'company_id': id,
            'type': this.yytypes
        };
        this.$http.post(api, data).then(res => {
            if (res.data.extend.news == 0) {
                if (res.data.extend.mnlist == []) {
                    this.gkList = [{}];
                } else {
                    this.gkList = res.data.extend.mnlist;
                }

                this.show = true;
                
            }
        }, res => {

        });
    },

    mounted() {
        this.comName = sessionStorage.getItem('companyName');
    },

    methods: {
        // 增加公司
        addCompany() {
            const that = this;
            const api = this.ApiUrl + 'company/addCompany';
            // let data = {
            // 	'company_name':,
            // 	'area_id':,
            // 	'address':,
            // 	'phone':,
            // 	'legalPerson':,
            // 	'industry':,
            // 	'xy':,
            // 	'information':
            // }
        },
        getidInfo(id) {
            
        },
        // 刷新页面
        reload() {
            location.reload();
        },
        // 返回主页
        backmast() {
            this.$router.push({
                path: '/adminlist'
            });
        },
        tabboxshow(index) {

        }

    }

};
</script>

<style scoped>
	.MenuItem-box {
		width: 100%;
		height: auto;
		min-height: 37.5rem;
		background-color: #FFFFFF;
		padding: 1.25rem;
	}

	.icon {
		font-size: 1.5rem;
	}

	.refresh {
		float: right;
		margin-right: 1.25rem;
	}

	.picbox {
		height: 12.5rem;
		width: 12.5rem;
		border: 1px solid #ccc;
	}

	.titlable {
		height: 24px;
		border-left: 0.125rem solid aquamarine;
		padding-left: 20px;
		line-height: 24px;
		margin-bottom: 20px;
	}

	.cominfo {
		display: flex;
		flex-direction: column;

	}

	.inptext {
		margin-top: 0.625rem;
		width: 25rem;
	}

	.inpuarea {
		margin-top: 0.625rem;
		width: 25rem;

	}

	.btnbox {
		margin-top: 1.25rem;
		width: 25rem;
		display: flex;

	}

	.btnbox>button {
		margin-right: 200px;
	}

	.ivu-tabs{
		overflow: auto;
	}
</style>
